import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import { gray, primary, white } from "../../colors";
import MyText from "../custom/MyText";

export default function TestQuestionSelectAnswer({
  selected,
  text,
  onPress,
  dir,
}) {
  return (
    <TouchableOpacity
      dir={dir}
      onPress={onPress}
      style={{
        marginVertical: 10,
        width: "100%",
        borderColor: primary,
        borderRadius: 12,
        borderWidth: 1,
        padding: 10,
        backgroundColor: selected ? primary : white,
      }}
    >
      <MyText
        fontFamily={"vazir"}
        style={{ color: selected ? white : gray, fontSize: 18 }}
      >
        {text}
      </MyText>
    </TouchableOpacity>
  );
}
